


import React, { useEffect, useState } from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
type AppProps = {
  imageDetails: any;
};
const PdfPreviewWithApi = ({ imageDetails }: AppProps) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [imageDetails]);

  

  const docs = [
    {
      uri: imageDetails,
      fileType: "pdf",
    },
  ];


  const headers = {
    "X-Access-Token": imageDetails?.split("?")[1],
    "Content-Type": "application/pdf",
  };

  return (
    <DocViewer
      key={key}
      style={{
        width: "100%",  // Adjust width as needed
        height: "500px",  // Adjust height as needed
        overflowY: "auto",
      }}
      documents={[...docs]}
      pluginRenderers={DocViewerRenderers}
      prefetchMethod="GET"
      requestHeaders={headers}
    />
  );
};

export default PdfPreviewWithApi;


